/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var IdCardIcon16Solid = forwardRef('IdCardIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.5 2A2.5 2.5 0 0 0 1 4.5v6A2.5 2.5 0 0 0 3.5 13h9a2.5 2.5 0 0 0 2.5-2.5v-6A2.5 2.5 0 0 0 12.5 2h-9Zm.25 3a.75.75 0 0 0-.75.75v2.5c0 .414.336.75.75.75h2.5A.75.75 0 0 0 7 8.25v-2.5A.75.75 0 0 0 6.25 5h-2.5ZM9 5.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5ZM9.5 7a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3Z" })));
});
